// External Dependencies
import { FC } from 'react';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';

// Internal Dependencies
import {
  ConfirmationDialog,
  EnhancedAlert,
} from 'components/shared';
import { useVerifyDistrict } from 'gql/mutations/districts';

// Local Typings
interface Props {
  adminPortalId: string;
  onClose: () => void;
  open: boolean;
}

// Component Definition
const VerifyDistrictDialog: FC<Props> = ({
  adminPortalId,
  onClose,
  open,
}) => {
  const [
    verifyDistrict,
    {
      error,
      loading,
    },
  ] = useVerifyDistrict({
    onCompleted: onClose,
  });

  const handleVerifyDistrict = () => {
    verifyDistrict({
      variables: {
        input: {
          id: adminPortalId,
          isVerified: true,
        },
      },
    });
  };

  return (
    <ConfirmationDialog
      confirmButtonAction={handleVerifyDistrict}
      confirmButtonText="Yes, Verify"
      description={(
        <>
          <Typography gutterBottom>
            You have verified that this admin portal is legitimate.
          </Typography>

          <Typography>
            Once verified, this admin portal will be able to use restricted features.
          </Typography>

          <Collapse in={Boolean(error)}>
            <EnhancedAlert
              severity="error"
              sx={{ marginTop: 2 }}
            >
              {error?.message}
            </EnhancedAlert>
          </Collapse>
        </>
      )}
      isSubmitting={loading}
      maxWidth="xs"
      onClose={onClose}
      open={open}
      title="Verify Admin Portal?"
    />
  );
};

export default VerifyDistrictDialog;
